// Destination d'après-connexion (`?next=…`), partagée par les DEUX écrans de connexion
// (mur bêta `/login` et compte utilisateur `/connexion`) — une règle en double finit toujours
// par diverger, et c'est celle qui empêche le hameçonnage.
//
// On n'accepte qu'un chemin INTERNE : commençant par UNE seule «/».
// Sans ça, `?next=https://faux-site` déposerait un visiteur fraîchement connecté sur la page
// d'un tiers, en pleine confiance — le lien de départ étant authentiquement le nôtre.
//
// ⚠️ Tester le seul premier «/» ne suffit pas : les navigateurs lisent «//site.com» et
// «/\site.com» comme des adresses EXTERNES. C'est le piège classique des correctifs naïfs.
// Écarte aussi les schémas exotiques («javascript:…»), qui ne commencent pas par «/».
export function safeNext(raw: string | null | undefined, fallback: string): string {
  if (!raw || raw[0] !== "/" || raw[1] === "/" || raw[1] === "\\") return fallback;
  return raw;
}
